import React from 'react';
import { TableExpandKeys } from '../../model';
import { renderExpandIconDownRight } from './func';

interface IProps {
  readonly children: React.ReactNode;
  readonly expandedKeys?: TableExpandKeys;
  readonly expandedText?: string;
  readonly foldText?: string;
  readonly id: string;
  readonly onChangeExpand?: (id: string, status: boolean) => void;
}

export const ExpandOperatePackage = (props: IProps) => {
  const { id } = props;
  const isExpand = props.expandedKeys ? props.expandedKeys.includes(id) : false;

  const onTreeExpand = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    if (props.onChangeExpand) {
      props.onChangeExpand(id, !isExpand);
    }
  };

  return (
    <div className="webkit-box td-btn-render" id={`id-${id}`}>
      <div className="expand-icon pointer-all" onClick={onTreeExpand}>
        {renderExpandIconDownRight(
          isExpand,
          props.expandedText,
          props.foldText
        )}
      </div>
      {props.children}
    </div>
  );
};
